import { AfterViewInit, Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { MessageService } from 'primeng/api';
import { ApiService } from '../../../services/api.service';
import { environment } from '../../../../environments/environment';
import { FileUpload } from 'primeng/fileupload';
import { Table } from 'primeng/table';
import { EditorComponent } from '@tinymce/tinymce-angular';
import { init } from '../../editorconfig';

@Component({
  selector: 'app-make-i-technical-negotiations',
  standalone: false,
  templateUrl: './make-i-technical-negotiations.component.html',
  styleUrl: './make-i-technical-negotiations.component.scss'
})
export class MakeITechnicalNegotiationsComponent implements OnInit, AfterViewInit {
  @Output() routeConfig: EventEmitter<any> = new EventEmitter();
  @Input() step: any;
  @Input() id: any
  @Input() getUrl: any
  @Input() postUrl: any
  @Input() schemeType: any
  @Output() IRA: EventEmitter<any> = new EventEmitter();
  @Output() generatePDFEmitter: EventEmitter<any> = new EventEmitter();
  @Output() stepCompleted = new EventEmitter<void>();
  tncForm: FormGroup;
  @Input() isEditable: boolean = false;
  @Input() stepDetails: any;
  @ViewChild('table') table: Table;
  proposalForm: FormGroup;
  challengeForm: FormGroup;
  payload: {
    proposal_id: any;
    proposal_name: any;
  };
  tncData: any;
  @ViewChild('fileUpload') fileUpload!: FileUpload;
  uploadedUrl: any;
  apiUrl = environment.APIUrl
  vendors: any;
  JustificationForm: FormGroup;
  isEditorDisabled: boolean = false;
  init: EditorComponent['init'] = init;
  resId: any
  userID: any;
  
  constructor(private messageService: MessageService, private fb: FormBuilder, private api: ApiService, private route: ActivatedRoute) {
    const role = sessionStorage.getItem('user_role_id');
    this.userID = role
  }

  ngOnInit(): void {
    this.route.queryParams.subscribe((params: any) => {
      const proposalId = params['id'];
      const proposalName = params['name'];
      this.payload = {
        proposal_id: proposalId,
        proposal_name: proposalName
      }
      this.tncForm = this.fb.group({
        tnc: ['']
      })
      this.JustificationForm = this.fb.group({
        comment: [''],
      });
      this.getStep();
    });
  }
  
  ngAfterViewInit() {
    setTimeout(() => {
      if (this.isEditable) {
        this.isEditorDisabled = false;
        this.JustificationForm.enable();
      } else {
        this.isEditorDisabled = true;
        this.JustificationForm.disable();
      }
      this.rebuildEditor()
    }, 3000);
  }
  
  editorReady = false;
  rebuildEditor() {
    this.editorReady = false; // destroy
    setTimeout(() => {
      this.init = this.getTinyInit(); // refresh config
      this.editorReady = true; // recreate editor
    }, 0);
  }
  
  getTinyInit(): EditorComponent['init'] {
    return {
      readonly: this.isEditorDisabled
    };
  }
  
  goToNextStep() {
    this.stepCompleted.emit();
  }
  
  getStep() {
    this.api.getAPI(`/make1/technical-negotiation/?proposal_step=${this.step.id}&proposal_step__proposal=${this.payload.proposal_id}`).subscribe((res: any) => {
      this.resId = res.id
      this.uploadedUrl = res.tec_report || null;
      this.JustificationForm.patchValue({
        comment: res.justification || ''
      });
      this.vendors = [];
      for (const vendorName in res.vendors) {
        const vendorEntries = res.vendors[vendorName];
        for (const entry of vendorEntries) {
          this.vendors.push({
            id: entry.id,
            vendor: entry.vendor,
            file: entry.file,
            status: entry.vendor_status,
            technical_negotiation: entry.technical_negotiation
          });
        }
      }
    })
  }

  uploadedFileName: string = '';
  file: File;
  onUpload(event: any): void {
    const file = event.files?.[0];
    this.uploadedFileName = file.name;
    this.file = file;
  }

  isHeaderAdd: boolean = false;
  headerName: string = '';
  tecData: any[] = [];
  tecDataHeader: any[] = [];

  getFileName(url: string): string {
    const fileName = url.split('/').pop() || 'Unknown File';
    return fileName.length > 35 ? fileName.substring(0, 35) + '...' : fileName;
  }
  
  clearUpload(fileUpload: any) {
    this.uploadedFileName = null;
    this.uploadedUrl = null;
    fileUpload.clear();
  }

  onRowEditInit(rowData: any) {
    rowData.originalData = { ...rowData };
  }

  onRowEditSave(rowData: any) {
    const formData = new FormData();
    formData.append('proposal_step', this.step.id);
    formData.append('vendor_id', rowData.id);
    formData.append('vendor_status', rowData.status);
    if (rowData.uploadedFile) {
      formData.append('file', rowData.uploadedFile);
    }
    this.api.putAPI(`/make1/technical-negotiation/`, formData).subscribe((res: any) => {
      this.messageService.add({ severity: 'success', summary: 'Success', detail: res.message || 'Vendor updated successfully' });
      this.table.cancelRowEdit(rowData);
      this.getStep();
    });
  }

  onRowEditCancel(rowData: any, index: number) {
    if (rowData.originalData) {
      this.vendors[index] = { ...rowData.originalData };
    }
  }
  
  onFileUpload(event: any, rowData: any): void {
    const file = event.target.files[0];
    if (file) {
      rowData.uploadedFile = file;
      rowData.uploadedFileName = file.name;
    }
  }
  
  onSubmit() {
    const justification = this.JustificationForm.get('comment')?.value;
    const formData = new FormData();
    if (this.schemeType == 'makeI') {
      if (this.file) {
        formData.append('tec_report', this.file);
      } else {
        formData.append('justification', justification);
      }
    }

    this.api.putAPI(`/make1/technical-negotiation/${this.resId}/`, formData).subscribe({
      next: () => {
        this.messageService.add({
          severity: 'success',
          summary: 'Success',
          detail: `Justification submitted`
        });
        this.fileUpload.clear()
        this.uploadedFileName = ''
        this.getStep()
      },
      error: () => {
        this.messageService.add({
          severity: 'error',
          summary: 'Error',
          detail: `Failed to submit justification`
        });
      }
    });
  }
  
  generatePDF() {
    const payload = {
      url: '/revenue/need/version-control/',
      data: [
        { key: "Proposal Name", value: this.payload.proposal_name },
        { key: "Comments", value: this.JustificationForm.get('comment')?.value },
      ]
    };
    this.generatePDFEmitter.emit(payload);
  }
}

